<section class="container p-0 pt-4 p-sm-4 px-xl-8 py-xl-9">
    <ng-container *ngIf="isPage(SLIDES_VIEW)">
        <div
            (click)="previousSlide()"
            [ngClass]="{
                disabled:
                    !selectedSlide || (!studentAssignment.description && selectedSlide.order === 0)
            }"
            class="circle-btn circle-previous d-none d-xl-block"
        >
            <div>
                <app-icon [type]="'Arrow-left'" class="d-block"></app-icon>
                <span>Previous</span>
            </div>
        </div>
        <div
            (click)="nextSlide()"
            [ngClass]="{ disabled: isLastSlide() }"
            class="circle-btn circle-next d-none d-xl-block"
        >
            <div class="d-flex flex-column justify-content-center align-items-center">
                <app-icon [type]="'Arrow-right'" class="d-block"></app-icon>
                <span>Next</span>
            </div>
        </div>
    </ng-container>

    <div class="student-assignment-container p-xs-6">
        <div class="row-auto title mb-5">
            <div class="col px-sm-7 px-xl-4">
                <h1 [title]="studentAssignment.title">
                    {{ studentAssignment.title }}
                </h1>
            </div>

            <div
                *ngIf="isPage(SLIDES_VIEW)"
                class="col-4 dropdown-wrapper p-3 d-none d-sm-block d-xl-none"
            >
                <ng-select
                    (change)="setSelectedSlide($event)"
                    [(ngModel)]="selectedSlideId"
                    [clearable]="false"
                    [markFirst]="true"
                    [searchable]="false"
                    bindLabel="name"
                    bindValue="id"
                    class="dropdown"
                    dropdownPosition="bottom"
                >
                    <ng-option *ngIf="studentAssignment.description" [value]="0"
                        >Introduction</ng-option
                    >
                    <ng-option
                        *ngFor="let slide of studentAssignment.slides"
                        [innerHTML]="slide.name | bypassSecurity: 'html'"
                        [value]="slide"
                    ></ng-option>
                </ng-select>
            </div>
        </div>
        <ng-container *ngIf="isPage(START_VIEW)">
            <div class="row-auto mb-5 mx-md-4">
                <div class="description col-xl-7">
                    Before you start your lesson, type in your name below for your teacher to see
                    your work.
                </div>
            </div>
            <div class="row-auto mb-5 mx-md-4">
                <div class="name-input col">
                    <app-input-box
                        [(inputModel)]="studentName"
                        class="selenium-input-name"
                        [maxLength]="150"
                        inputType="text"
                        label="Name"
                    ></app-input-box>
                </div>
            </div>
            <div class="row-auto mb-9 mx-md-4">
                <div class="description col-xl-7">
                    Please do not provide any personal information on this assignment, such as your
                    address, e-mail address, or phone number.
                </div>
            </div>

            <div [ngClass]="{ invisible: studentName }" class="info-text mb-2 mx-md-4">
                Enter name above to continue
            </div>
            <app-button class="mx-md-4" (click)="startLesson()" [disable]="isNameInvalid()"
                >Start Lesson</app-button
            >
        </ng-container>

        <ng-container *ngIf="isPage(SLIDES_VIEW)">
            <div class="mb-xs-12 mb-xl-8 d-xl-flex">
                <div class="col-xl-7 px-md-4">
                    <h4
                        *ngIf="selectedSlide"
                        [innerHTML]="selectedSlide.name | bypassSecurity: 'html'"
                        class="slide-title mb-5"
                    ></h4>

                    <ng-container *ngIf="!selectedSlide && studentAssignment.description">
                        <div
                            [innerHTML]="studentAssignment.description | bypassSecurity: 'html'"
                        ></div>
                    </ng-container>

                    <ng-container *ngIf="selectedSlide && selectedSlide.type === slideTypes.MEDIA">
                        <ng-container *ngIf="selectedSlide.asset.error">
                            <div class="error p-8">
                                <app-icon [type]="'Exclamation-triangle'" class="pe-4"> </app-icon
                                >{{ selectedSlide.asset.error }}
                            </div>
                        </ng-container>
                        <ng-container *ngIf="selectedSlide.asset.isVideo()">
                            <app-video
                                [gtmVideoJsInfo]="selectedSlide.asset.getGTMVideoJSInfo()"
                                [muxData]="selectedSlide.asset.getMuxData()"
                                [videoMedia]="selectedSlide.asset.selectedMedia"
                            ></app-video>
                        </ng-container>

                        <ng-container *ngIf="selectedSlide.asset.isAudio()">
                            <app-audio
                                [audioMedia]="selectedSlide.asset.selectedMedia"
                                [gtmVideoJsInfo]="selectedSlide.asset.getGTMVideoJSInfo()"
                                [muxData]="selectedSlide.asset.getMuxData()"
                            ></app-audio>
                        </ng-container>

                        <ng-container *ngIf="selectedSlide.asset.isImage()">
                            <app-image-preview
                                [imageMedia]="selectedSlide.asset.selectedMedia"
                            ></app-image-preview>
                        </ng-container>

                        <ng-container *ngIf="selectedSlide.asset.isDocument()">
                            <app-document-preview
                                [documentMedia]="selectedSlide.asset.selectedMedia"
                            ></app-document-preview>
                        </ng-container>

                        <ng-container *ngIf="selectedSlide.asset.isGenericInteractive()">
                            <app-generic-interactive-preview
                                [interactiveAsset]="selectedSlide.asset"
                            ></app-generic-interactive-preview>
                        </ng-container>
                        <div
                            [innerHTML]="selectedSlide.description | bypassSecurity: 'html'"
                            class="mt-3"
                        ></div>
                    </ng-container>

                    <ng-container *ngIf="selectedSlide && selectedSlide.type === slideTypes.TEXT">
                        <div [innerHTML]="selectedSlide.description | bypassSecurity: 'html'"></div>
                    </ng-container>

                    <ng-container
                        *ngIf="selectedSlide && selectedSlide.type === slideTypes.QUESTION"
                    >
                        <app-question-wizard
                            [preview]="preview"
                            [questionsSlide]="selectedSlide"
                            [resultId]="resultId"
                        ></app-question-wizard>
                    </ng-container>

                    <div
                        *ngIf="selectedSlide?.brand || selectedSlide?.creditsLink"
                        class="credits mt-4"
                    >
                        <div *ngIf="selectedSlide?.brand" class="brand">
                            Provided by: <span>{{ selectedSlide.brand }}</span>
                        </div>
                        <app-link
                            *ngIf="selectedSlide?.creditsLink"
                            [href]="selectedSlide?.creditsLink"
                            class="float-end gtm-student-assignment-credits-link selenium-student-assignment-credits-link"
                            target="_blank"
                        >
                            Credits
                        </app-link>
                    </div>
                </div>
                <div class="col-xl-5 px-4">
                    <app-slides-menu
                        (clickSlide)="setSelectedSlide($event)"
                        [hasIntro]="!!studentAssignment.description"
                        [selectedSlide]="selectedSlide"
                        [slides]="studentAssignment.slides"
                        class="d-none d-xl-block"
                    ></app-slides-menu>
                </div>
            </div>
            <div class="row mx-md-1 mb-md-2">
                <div class="col-7">
                    <app-button
                        (click)="previousSlide()"
                        [disable]="
                            !selectedSlide ||
                            (!studentAssignment.description && selectedSlide.order === 0)
                        "
                        class="me-3"
                        ><app-icon type="Arrow-left2"></app-icon> Previous</app-button
                    >
                    <app-link
                        *ngIf="userService.isStudent()"
                        [href]="'/student/assignments/'"
                        class="d-none d-sm-inline-block"
                    >
                        <app-button [buttonClasses]="'hallow'">Save for Later</app-button>
                    </app-link>
                </div>

                <div class="col-5">
                    <app-button (click)="nextSlide()" *ngIf="!isLastSlide()" class="float-end"
                        >Next <app-icon type="Arrow-right2"></app-icon
                    ></app-button>
                    <app-button
                        (click)="submitAssignment()"
                        *ngIf="isLastSlide() && !studentAssignment.isILP"
                        [disable]="!isSubmitEnabled"
                        class="float-end gtm-assignment-submit"
                        >Submit</app-button
                    >
                    <span *ngIf="isLastSlide() && studentAssignment.isILP" class="float-end"
                        >Launch and complete the Interactive Lesson to submit your work.</span
                    >
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isPage(COMPLETE_VIEW)">
            <div class="row-auto mb-3 mx-md-4">
                <div class="col">
                    <h4 class="slide-title">You’re done!</h4>
                </div>
            </div>
            <div class="row-auto mb-8 mx-md-4">
                <div class="col description">Your results were sent to your teacher!</div>
            </div>
            <div class="row-auto mx-md-4">
                <div class="d-flex align-items-center">
                    <app-button (click)="resetAssignment()" class="col-xs-5"
                        >Take it Again</app-button
                    >
                    <a class="link fw-bold col-xs-8" routerLink="/student"
                        >Explore PBS LearningMedia</a
                    >
                </div>
            </div>
        </ng-container>
        <app-mobile-slides-menu
            (clickNext)="nextSlide(true)"
            (clickPrevious)="previousSlide()"
            (clickSlide)="setSelectedSlide($event)"
            *ngIf="isPage(SLIDES_VIEW)"
            [hasIntro]="!!studentAssignment.description"
            [selectedSlide]="selectedSlide"
            [slides]="studentAssignment.slides"
            class="d-sm-none"
        ></app-mobile-slides-menu>
    </div>
</section>
